export default __webpack_public_path__ + "static/media/smedetoften-property-01.5cec9ebd.jpg";